import { render, staticRenderFns } from "./RulesSearch.vue?vue&type=template&id=2e331f90&"
import script from "./RulesSearch.vue?vue&type=script&lang=js&"
export * from "./RulesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports